import { BlockSkeleton } from 'components/secondaryMarket/shared/Blocks/BlockSkeleton';
import { FieldSkeleton } from 'components/secondaryMarket/shared/FieldSkeleton';
import { VerticalFormGroupSkeleton } from 'components/shared/FormGroup/VerticalFormGroupSkeleton';
import { FC } from 'react';

export const CpOrderBookingInformationSkeleton: FC<{ className?: string }> = ({ className }) => {
  return (
    <BlockSkeleton id="booking-information" className={className} labelSize={20}>
      <div>
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={10} className="col-md-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
          <VerticalFormGroupSkeleton labelSize={10} className="col-md-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={15} className="col-md-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
          <VerticalFormGroupSkeleton labelSize={15} className="col-md-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={15} className="col-md-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
          <VerticalFormGroupSkeleton labelSize={15} className="col-md-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>
      </div>
    </BlockSkeleton>
  );
};

CpOrderBookingInformationSkeleton.displayName = 'CpOrderFormBookingInformationSkeleton';
